import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-allnews',
  templateUrl: './allnews.component.html',
  styleUrls: ['./allnews.component.scss']
})
export class AllnewsComponent implements OnInit {

  allNewsData: any[] = [];
  showDeptMenu = false;

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.setMeta('News Faculty of Humanities & Social Sciences',
      'All news')

    // Load active news
    this._actRoute.paramMap.subscribe(params => {
      const deptId = this._actRoute.snapshot.params.deptId;
      const infoId = this._actRoute.snapshot.params.infoId;

      if(deptId != undefined && infoId != undefined){
        this.getActiveArchiveNewsByDept(deptId, infoId);
        this.showDeptMenu=true;
      } else {
        this.getAllActiveArchiveNews();
        this.showDeptMenu=false;
      }
    });
  }

  navigatePage(current: string, param?: number) {
    if (current === 'info') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/info/'],navigationExtras);
    }
  }

  // Get news  data - ID 1
  getAllActiveArchiveNews(){
    this._info.getActiveArchiveInfo(1).subscribe (
      (response: HssResponse<any>) => {
        this.allNewsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  getActiveArchiveNewsByDept(deptId: number, infoId: number){
    this._info.getActiveArchiveInfoByDept(deptId, infoId).subscribe (
      (response: HssResponse<any>) => {
        this.allNewsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
